import type { Messages } from '../messages';

import { accountEn } from './account';
import { channelsEn } from './channels';
import { emergencyEn } from './emergency';
import { freshnessEn } from './freshness';
import { historyEn } from './history';
import { homeEn } from './home';
import { onboardingEn } from './onboarding';
import { positionsEn } from './positions';
import { reasonEn, reasonFallbackEn } from './reason.en';
import { sessionEn } from './session';
import { settingsEn } from './settings';

/** English texts. Wording provisional until Q3 (tone). Reason texts: C2, in reason.en.ts. */
export const en: Messages = {
  app: { title: 'FXMate', navigation: 'Main navigation' },
  tabs: { home: 'Home', channels: 'Channels', positions: 'Positions', account: 'Account' },
  home: homeEn,
  freshness: freshnessEn,
  onboarding: onboardingEn,
  positions: positionsEn,
  history: historyEn,
  session: sessionEn,
  settings: settingsEn,
  emergency: emergencyEn,
  account: accountEn,
  channels: channelsEn,
  // C2: the catalogue lives in reason.en.ts so this file stays a readable index of the screens' texts.
  reason: reasonEn,
  reasonFallback: reasonFallbackEn,
};
